export default __webpack_public_path__ + "static/media/play-red.504ff886.png";